import React from "react";
import { Grid, Responsive, GridRow, Icon } from "semantic-ui-react";
import ProfileBox from "../../Components/ProfileBox/ProfileBox";
// import RecentFeedback from "./RecentFeedback";
import NextExpectedPayment from "./NextExpectedPayment";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./Dashboard.css";
import DashboardLink from "./DashboardLink";
import { getProgressCollege } from "../../Helper/CollegeHelper";
import { handleCollegeMultiDateBookings } from "../Bookings2/Helper";
import { API } from "../../API";
import JobBoardComponent from "./JobComponentCollege";
import { Link } from "react-router-dom";
import { mapStateToCityForET, shortenStatesName, teacherResponse } from "../../Helper";
import { buildStepContent } from "./setupStepContent";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import Spinner from '../../Components/Spinner/Spinner'
import { notify } from "react-notify-toast"
import Modal from '../../Components/Modal/Modal';
import ConfirmAndCancel from '../../Components/Buttons/ConfirmAndCancel';
import CheckableButton from "../../Components/CheckableButton/CheckableButton"
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import CurrentInvoices from "./CurrentInvoice";
const Moment = require("moment");
const MomentRange = require("moment-range");
const moment = MomentRange.extendMoment(Moment);

export let profileIncomplete
class CollegeDashboardContents extends React.Component {
  state = {
    // the following needs to be updated by check status
    progress: 0,
    progress_check: [false, false, false, false, false, false, false],
    bookings: [],
    upcoming_bookings: [],
    recent_booking: null,
    bookingsLoaded: false,
    onLoadET: true,
    selectedCampus: this.props.campuses?.filter(campus => campus.state)?.[0],
    onCheckCampus: this.props.campuses?.filter(campus => campus.state)?.[0],
    etTeacher: {},
    showSelectCampusModel: false,
    screenWidth: window.innerWidth,
    isViewAsAdmin: this.props.isViewAsAdmin // hide some components if this page is viewed by admin
  };

  componentDidMount = () => {
    window.addEventListener("resize", this.handleResize);
    if(!this.state.isViewAsAdmin && this.state.selectedCampus?.state) {
      this.etInterval = setInterval(() => {
        const teacherType = this.props.user?.is_childcare_centre ? "ecec" : "elicos"
        API.getETTeacherV2(this.state.onCheckCampus, teacherType).then((res) => {
          const etTeacher = res?.data?.data
          if(res?.data?.data) {
            const oldCount = this.state.etTeacher?.summary?.[shortenStatesName(this.state.selectedCampus?.state)]
            const newCount = etTeacher?.summary?.[shortenStatesName(this.state.selectedCampus?.state)]
            const oldStatus = this.state.etTeacher?.summary?.status
            const newStatus = etTeacher?.summary?.status
            const oldTime = this.state.etTeacher?.summary?.opens_in
            const newTime = etTeacher?.summary.opens_in
            if(oldCount !== newCount || oldStatus !== newStatus || oldTime !== newTime) {
              this.setState({
                etTeacher: etTeacher
              })
            }
            else {
              console.log("Reloaded ET with no change")
            }
          }
          else {
            console.log("Fail to reload ET")
          }
        })
      }, 1*60*1000)
    }
    
    const { user, institution, campuses, personnel, classes } = this.props;
    const { progress, p_c } = getProgressCollege(
      user,
      institution,
      classes,
      campuses,
      personnel
    );
    this.setState({
      progress: progress,
      progress_check: p_c,
    });
    API.getAllTeachersBrief().then((res) => {
      this.getBookings(institution, res.data);
    });

    if(!this.state.isViewAsAdmin && this.state.selectedCampus?.state) {
      const teacherType = this.props.user?.is_childcare_centre ? "ecec" : "elicos"
      API.getETTeacherV2(this.state.selectedCampus, teacherType).then((res) => {
        // console.log("getETTeacher: ", res.data)
        this.setState({
          etTeacher: res?.data?.data,
          onLoadET: false
        })
      })
    }
    

    // console.log("college dashboard")
    // console.log("campuses: ", campuses, this.state.selectedCampus)
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.etInterval)
  }

  handleResize = () => {
    this.setState({
      screenWidth: window.innerWidth
    });
  };

  getBookings = (inst, teachers) => {
    //Get access to all the bookings of the current user
    API.getCampusBookingsByInstitutionID(inst._id)
      .then((result) => {
        let list = handleCollegeMultiDateBookings(result.data)
          .filter((booking) => {
            return (
              !booking.cancelled_by_inst &&
              booking.teacher_response !== teacherResponse.cancelled
            );
          })
          .map((job) => {
            let newJob = { ...job };
            // console.log(newJob);
            if (job.teacher_id) {
              // console.log(job.teacher_id)
              if (job.teacher_response === teacherResponse.accepted) {
                newJob.teacher = teachers.find(
                  (teacher) => teacher._id === job.teacher_id
                );
              }
            }
            return newJob;
          })
          .sort((a, b) => {
            if (a.booking_date === b.booking_date) {
              return a.arrival_time > b.arrival_time ? 1 : -1;
            } else return a.booking_date > b.booking_date ? 1 : -1;
          });
        // this.setState({ bookings: list, bookingsLoaded: true })
        let past_bookings = [];
        let future_bookings = [];
        const today = new Date();
        const today_date = moment(new Date()).format("YYYY-MM-DD");
        const today_time = `${today
          .getHours()
          .toString()
          .padStart(2, "0")}:${today.getMinutes().toString().padStart(2, "0")}`;
        list.forEach((booking) => {
          const compare_date = booking.end_booking_date || booking.booking_date;
          if (
            compare_date > today_date ||
            (compare_date === today_date && booking.end_time > today_time)
          ) {
            future_bookings.push(booking);
          } else {
            if (booking.teacher_response === "accepted") {
              past_bookings.push(booking);
            }
          }
        });
        this.setState({
          bookings: list,
          upcoming_bookings: future_bookings,
          recent_booking: past_bookings[past_bookings.length - 1],
          bookingsLoaded: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  setShowSelectCampusModel = (isShow) => {
    this.setState({
      showSelectCampusModel: isShow
    })
  }

  onChangeETCampus = () => {
    // console.log("confirm")
    this.setState({
      onLoadET: true,
      showSelectCampusModel: false,
    })
    const teacherType = this.props.user?.is_childcare_centre ? "ecec" : "elicos"
    API.getETTeacherV2(this.state.onCheckCampus, teacherType).then((res) => {
      this.setState({
        etTeacher: res?.data?.data,
        selectedCampus: this.state.onCheckCampus,
        onLoadET: false
      })
    })
  }

  getDateText = (date) => {
    const now = moment.tz(new Date(), "Australia/Melbourne").format('ddd')
    const otherDate = moment.tz(date, "Australia/Melbourne").format('ddd')
    // console.log("check date: ", now, otherDate)
    return now === otherDate ? "today" : "tomorrow"
  } 

  render() {
    profileIncomplete = !(
      this.state.progress_check.logo && this.state.progress_check.courses
    );
    // let profileIncomplete = true

    const disabledMessage = this.props?.user?.is_childcare_centre
      ? "Please add your company logo and rooms & programs in your Centre Profile"
      : "Please add your company logo and courses delivered in your Institution Profile"

    // const statusET = this.state.etTeacher?.summary?.status
    const statusET = "CLOSED"

    const countET = this.state.etTeacher?.summary?.[shortenStatesName(this.state.selectedCampus?.state)]
    console.log("width: ", this.state.screenWidth)
    // console.log("data: ", statusET, countET)
    return (
      <div className="mt-0 upcoming-classes-spacing">
        {
          !this.state.isViewAsAdmin &&
          this.state.selectedCampus?.state &&
          !this.state.onLoadET ? (
          this.state.etTeacher?.summary && this.state.selectedCampus?.state && (
          <React.Fragment>

            {/* OPEN case with 1 teacher available at least */}
            {
              statusET === "OPEN" && countET > 0 && (
                <div className="d-flex justify-content-between align-items-center py-2 px-5 mb-3 bg-open mr-15">
                  
                  <div className="text-white my-3 open-info">
                    {
                      !this.props?.user?.is_childcare_centre && (
                        <p className="text-center fs-20">Morning Session for {this.getDateText(this.state.etTeacher.summary.Date)}</p>
                      )
                    }
                    <p className="text-center et-date">{moment(this.state.etTeacher.summary.Date).format('ddd DD/MM')}</p>
                    <p className="text-center fs-20">{mapStateToCityForET(shortenStatesName(this.state.selectedCampus?.state))}</p>
                    <p className="text-center fs-14 open-text pointer btn-change-location" onClick={() => this.setShowSelectCampusModel(true)}>Change Location</p>
                  </div>
                  <div className="open-logo d-flex flex-column justify-content-start">
                    <img className="open-img" width={280} src="../../assets/img/open-icon.png" />
                    {this.state.screenWidth < 1220 && (
                      <div className="open-content">
                        <p className="text-center et-date">
                          <span className="text-white">{countET > 5 ? "5+" : countET}</span>
                          {/* <span className="text-white">{" Teachers"} </span> */}
                          <span className="text-white">{" AVAILABLE"}</span>
                        </p>
                      </div>
                    )}
                    {this.state.screenWidth <= 530 && (
                    <div className="">
                      <Link
                        className="open-booking-btn"
                        id="openbooking"
                        title="Booking"
                        to={`/CollegeCalendar?date=${moment(this.state.etTeacher.summary.Date).format('YYYY-MM-DD')}`}
                      >
                        BOOK NOW
                      </Link>
                    </div>
                    )}
                  </div>
                  {this.state.screenWidth >= 1220 && (
                  <div className="open-content">
                    <p className="text-left et-date">
                      <span className="text-white">{countET > 5 ? "5+" : countET}</span>
                      {/* <span className="text-white">{" Teachers"} </span> */}
                      <span className="text-white">{" AVAILABLE"}</span>
                    </p>
                  </div>
                  )}
                  {this.state.screenWidth > 530 && (
                  <div className="">
                    <Link
                      className="open-booking-btn"
                      id="openbooking"
                      title="Booking"
                      to={`/CollegeCalendar?date=${moment(this.state.etTeacher.summary.Date).format('YYYY-MM-DD')}`}
                    >
                      BOOK NOW
                    </Link>
                  </div>
                  )}
                </div>
              )
            }

            {/* SOLD OUT case with no available teacher */}
            {
              statusET === "OPEN" && countET == 0 && (
                <div className="d-flex justify-content-between align-items-center py-2 px-5 mb-3 bg-sold-out mr-15">
                  <div className="text-white my-3 sold-out-info">
                    {
                      !this.props?.user?.is_childcare_centre && (
                        <p className="text-center fs-20">Morning Session for {this.getDateText(this.state.etTeacher.summary.Date)}</p>
                      )
                    }
                    <p className="text-center et-date">{moment(this.state.etTeacher.summary.Date).format('ddd DD/MM')}</p>
                    <p className="text-center fs-20">{mapStateToCityForET(shortenStatesName(this.state.selectedCampus?.state))}</p>
                    <p className="text-center fs-14 open-text pointer btn-change-location" onClick={() => this.setShowSelectCampusModel(true)}>Change Location</p>
                  </div>
                  <div className="sold-out-logo d-flex flex-column justify-content-start align-items-center">
                    <img className="sold-out-img" width={315} src="../../assets/img/sold-out-icon.png" />
                    {this.state.screenWidth <= 500 && (
                    <div className="sold-out-content">
                      <p className="text-center et-date">
                        <span className="text-white">{countET}</span>
                        {/* <span className="text-white">{" Teachers"} </span> */}
                        <span className="text-white">{" AVAILABLE"}</span>
                      </p>
                      <p className="text-center text-white fs-12">
                        ET booking for {this.getDateText(this.state.etTeacher.summary.Date)} {moment(this.state.etTeacher.summary.Date).format('DD/MM')}
                      </p>
                      <p className="text-center text-white fs-12">
                        will open in {this.state.etTeacher?.summary?.opens_in || "a few minutes"}
                      </p>
                    </div>
                    )}
                  </div>
                  {this.state.screenWidth > 500 && (
                  <div className="sold-out-content">
                    <p className="text-center et-date">
                      <span className="text-white">{countET}</span>
                      {/* <span className="text-white">{" Teachers"} </span> */}
                      <span className="text-white">{" AVAILABLE"}</span>
                    </p>
                    <p className="text-center text-white fs-16">
                      ET booking for {this.getDateText(this.state.etTeacher.summary.Date)} {moment(this.state.etTeacher.summary.Date).format('DD/MM')}
                    </p>
                    <p className="text-center text-white fs-16">
                      will open in {this.state.etTeacher?.summary?.opens_in || "a few minutes"}
                    </p>
                  </div>
                  )}
                </div>
              )
            }


            {/* CLOSED case */}
            {
              statusET.includes("CLOSED") && (
                <div className="d-flex justify-content-between align-items-center py-2 px-5 mb-3 bg-close mr-15">
                  <div className="my-3 close-info">
                    {
                      !this.props?.user?.is_childcare_centre && (
                        <p className="text-center fs-20">Morning Session for today</p>
                      )
                    }
                    <p className="text-center et-date">{moment.tz(new Date(), "Australia/Melbourne").format('ddd DD/MM')}</p>
                    <p className="text-center fs-20">{mapStateToCityForET(shortenStatesName(this.state.selectedCampus?.state))}</p>
                    <p className="text-center fs-14 close-text pointer btn-change-location" onClick={() => this.setShowSelectCampusModel(true)}>Change Location</p>
                  </div>
                  <div className="close-logo d-flex flex-column justify-content-start align-items-center">
                    <img className="close-img" width={270} src="../../assets/img/close-icon.png" />
                    {this.state.screenWidth <= 500 && (
                    <div className="close-content">
                      <p className="text-center et-date">
                        <span className="">0</span>
                        {/* <span className="">{" Teachers"} </span> */}
                        <span className="">{" AVAILABLE"}</span>
                      </p>
                      <p className="text-center fs-14">
                        ET booking for {this.getDateText(this.state.etTeacher.summary.Date)} {moment(this.state.etTeacher.summary.Date).format('DD/MM')}
                      </p>
                      <p className="text-center fs-14">
                        will open in {this.state.etTeacher.summary.opens_in || "a few minutes"}
                      </p>
                    </div>
                    )}
                  </div>
                  {this.state.screenWidth > 500 && (
                  <div className="close-content">
                    <p className="text-center et-date">
                      <span className="">0</span>
                      {/* <span className="">{" Teachers"} </span> */}
                      <span className="">{" AVAILABLE"}</span>
                    </p>
                    <p className="text-center fs-16">
                      ET booking for {this.getDateText(this.state.etTeacher.summary.Date)} {moment(this.state.etTeacher.summary.Date).format('DD/MM')}
                    </p>
                    <p className="text-center fs-16">
                      will open in {this.state.etTeacher.summary.opens_in || "a few minutes"}
                    </p>
                  </div>
                  )}
                </div>
              )
            }
          </React.Fragment>
          )
        ) : (
          this.state.bookingsLoaded && !this.state.isViewAsAdmin && this.state.selectedCampus?.state && <Spinner small />
        )}
        <div className="mt-0 upcoming-classes-spacing">
          <div className="w-100 d-flex justify-content-between align-items-center guide-tour-icon">
            <div />
            <HoverIcon
              icon="info"
              circular
              inverted
              className="search-help-icon"
              onClick={this.props.openTour}
              text="Click for guide"
            />
          </div>
          {this.state.bookingsLoaded ? (
            <React.Fragment>
              <div className="row flex-row mx-0 py-2 upcoming-inner">
                {!!this.state.upcoming_bookings.length ? (
                  this.state.upcoming_bookings.length === 1 ? (
                    <div
                      className="col-lg-6"
                      key={this.state.upcoming_bookings[0]._id}
                    >
                      <JobBoardComponent
                        job={this.state.upcoming_bookings[0]}
                        bookings={this.state.bookings}
                        campuses={this.props.campuses}
                      />
                    </div>
                  ) : (
                    [<div
                      className="col-lg-4"
                      key={this.state.upcoming_bookings[0]._id}
                    >
                      <JobBoardComponent
                        job={this.state.upcoming_bookings[0]}
                        bookings={this.state.bookings}
                        campuses={this.props.campuses}
                        smallHeader={true}
                      />
                    </div>,
                    <div
                      className="col-lg-4"
                      key={this.state.upcoming_bookings[1]._id}
                    >
                      <JobBoardComponent
                        job={this.state.upcoming_bookings[1]}
                        bookings={this.state.bookings}
                        campuses={this.props.campuses}
                        smallHeader={true}
                      />
                    </div>])
                ) : (
                  <div className="col-lg-6">
                    <ProfileBox header="Upcoming Booking" />
                  </div>
                )}
                {!!this.state.recent_booking ? (
                  <div className={this.state.upcoming_bookings.length > 1 ? "col-lg-4" : "col-lg-6"}
                    key={this.state.recent_booking._id}>
                    <JobBoardComponent
                      smallHeader={this.state.upcoming_bookings.length > 1}
                      job={this.state.recent_booking}
                      bookings={this.state.bookings}
                      campuses={this.props.campuses}
                      recent
                    />
                  </div>
                ) : (
                  <div className={this.state.upcoming_bookings.length > 1 ? "col-lg-4" : "col-lg-6"}>
                    <ProfileBox
                      header="Last Completed"
                      smallHeader={this.state.upcoming_bookings.length > 1} />
                  </div>
                )}
              </div>
            </React.Fragment>
          ) : (
            <Spinner small />
          )}
        </div>
        <div className="mx-3 mt-5">
          <ProfileBox header="Quick Actions">
            <div className="row flex-row mx-2 py-2 quick-action-links">
              <div className={"p-2 dashboard-link-college" + (this.props.user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                <DashboardLink
                  className='make-booking-link'
                  pathname="/CollegeCalendar"
                  iconName="calendar check outline"
                  text="Make a Booking"
                  index={0}
                  disabled={!(this.props.classes && this.props.classes.length > 0)}
                  disabledText="Please navigate to your Timetable to set up a class first."
                />
              </div>

              <div className={"p-2 dashboard-link-college" + (this.props.user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                <DashboardLink
                  className='post-job-link'
                  pathname="/PostJobDraft"
                  iconName="briefcase"
                  text="Post a Vacancy"
                  disabled={profileIncomplete}
                  disabledText={disabledMessage}
                  index={1}
                />
              </div>

              <div className={"p-2 dashboard-link-college" + (this.props.user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                <DashboardLink
                  className='search-teachers-link'
                  pathname="/SearchTeachers"
                  iconName="search"
                  text={this.props?.user?.is_childcare_centre ? "Search Educators" : "Search Teachers"}
                  disabled={profileIncomplete}
                  disabledText={disabledMessage}
                  index={2}
                />
              </div>

              <div className={"p-2 dashboard-link-college" + (this.props.user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                <DashboardLink
                  className='view-favourites-link'
                  pathname="/FavouriteTeachers"
                  iconName="heart"
                  text="View Favourites"
                  disabled={profileIncomplete}
                  disabledText={disabledMessage}
                  index={3}
                />
              </div>

              {
                !this.props?.user?.is_childcare_centre && (
                  <div className={"p-2 dashboard-link-college" + (this.props.user?.is_childcare_centre ? " dashboard-link-college-ecec" : "")}>
                    <DashboardLink
                      className="send-lesson-plan-link"
                      pathname="/SendLessonMaterials"
                      iconName="paper plane"
                      text="Send Lesson Plan"
                      // disabled
                      disabledText="Not available"
                      index={4}
                    />
                  </div>
                )
              }
            </div>
          </ProfileBox>
        </div>

        {/* <div className={"mx-3 pt-4 dashboard-progress" + (this.state.progress == 100 ? ' d-none' : '')}>
          <ProfileBox header="SETUP PROGRESS - ADD TO PROFILE">
            <div className="row flex-vertical-center">
              {/* this is the left part of the progress bar to show percentage */}
              {/* <div className="col-lg-2">
                <div className="row py-6">
                  <div className="col-md-3 col-lg-2" />
                  <div className="col-md-6 col-lg-8">
                    <CircularProgressbar
                      value={this.state.progress}
                      text={`${this.state.progress}%`}
                    /> */}
                    {/* <p className='text-center font-weight-bold pt-md-2'>
                {' '}
                Setup process
              </p> */}
                  {/* </div>
                  <div className="col-md-2" />
                </div>
              </div>

              <div className="col-lg-10">
                <div className="row m-2">
                  <div className="col-md-3">
                    <Responsive minWidth={768}>
                      {buildStepContent(
                        "Company Logo",
                        "/Profile",
                        this.state.progress_check.logo
                      )}

                      {buildStepContent(
                        "Setup Campuses",
                        "/Campus",
                        this.state.progress_check.campuses
                      )}
                    </Responsive>
                  </div>

                  <div className="col-md-3">
                    <Responsive minWidth={768}>
                      {buildStepContent(
                        "Website URL",
                        "/Profile",
                        this.state.progress_check.website
                      )}

                      {buildStepContent(
                        "Setup Timetable",
                        "/Timetable",
                        this.state.progress_check.classes
                      )}
                    </Responsive>
                  </div>

                  <div className="col-md-3">
                    <Responsive minWidth={768}>
                      {buildStepContent(
                        "Profile Photo",
                        "/CollegeAccount",
                        this.state.progress_check.profile_photo
                      )}

                      {buildStepContent(
                        "Personnel",
                        "/Personnel",
                        this.state.progress_check.personnel
                      )}
                    </Responsive>
                  </div> */}

                  {/* <div className="col-md-3">
                    <Responsive minWidth={768}>
                      {buildStepContent(
                        "Courses Delivered",
                        "/Profile#updateCourseDeliver",
                        this.state.progress_check.courses
                      )}

                      {/* buildStepContent(
                    "Payment Method",
                    "javascript:void(0)",
                    this.state.progress_check.payment,
                    true,
                    true
                  ) */}
                    {/* </Responsive>
                  </div>
                </div>
              </div>
            </div>
          </ProfileBox>
        </div> */}

        <div className="recent-feedback-payment py-4">
          <div className="row flex-row mx-0">
            {
              !this.props.user?.is_childcare_centre && (
                <div className="col-lg-6">
                  <ProfileBox header="Recent Feedback" />
                </div>
              )
            }
            <div className="col-lg-6">
              <CurrentInvoices user={this.props.user} />
            </div>
          </div>
        </div>

        <Modal
            show={this.state.showSelectCampusModel}
            header="Choose Campus"
            className="export-booking-modal"
            onClose={() => this.setShowSelectCampusModel(false)}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-8">
                <ButtonContainer
                  label="Select campus"
                  className="p-0 mx-0"
                >
                  <div className="col-md-12 px-0">
                    {this.props.campuses?.filter(campus => campus.state)?.map((campus, index) => {
                      return (
                        <CheckableButton
                          checkbox
                          // noBorder
                          id={campus._id}
                          title={index}
                          onChange={() => this.setState({onCheckCampus: campus})}
                          checked={campus._id === this.state.onCheckCampus._id}
                        >
                          {campus.address_line1 + (
                            campus.address_line2 ? ', ' + campus.address_line2 : '') + ', ' + campus.suburb}
                        </CheckableButton>
                      )
                    })}
                  </div>
                </ButtonContainer>
              </div>
              <div className="w-100">
                <ConfirmAndCancel
                  onCancel={() => this.setShowSelectCampusModel(false)}
                  cancelText='Go Back'
                  onConfirm={() => {
                    this.onChangeETCampus()
                  }}
                  confirmText='Change'
                />
              </div>
            </div>
          </Modal>
      </div>
  )}
}

export default CollegeDashboardContents;
